import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function t(d, e) {
  return r(), o("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.75 3c.414 0 .75.53.75 1.184v12.632c0 .654-.336 1.184-.75 1.184s-.75-.53-.75-1.184V4.184C10 3.53 10.336 3 10.75 3",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 10.75c0-.414.53-.75 1.184-.75h12.632c.654 0 1.184.336 1.184.75s-.53.75-1.184.75H4.184C3.53 11.5 3 11.164 3 10.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const u = { render: t };
export {
  u as default,
  t as render
};
